/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useEffect } from "react";
//import { AdminLandingPage } from "../../../widgets/admin-landing-page-widget-react";
import { LandingPage } from "../../../widgets/landing-page-widget";
import "../../../vlinder.min.css";
import { useSMBrandPage, useSMLandingPage } from "../machines";
import { StateOSD } from "@vlinder-web/state-osd-v2-widget-react";

export const ContainerComm = (props: any) => {
  const { brandsPageMachine, brandsPageSend, brandsPageState } =
    useSMBrandPage({});

  const _renderPage = () => {
    if (brandsPageState?.matches("RENDER_PAGE")) {
      console.log(brandsPageState?.event?.data?.value)
      return (
        <LandingPage {...(brandsPageState?.event?.data?.value || {})} />
      );
    }
    if (brandsPageState?.matches("GET_PAGE_CONTENT") ||
      brandsPageState?.matches("RENDER_BRAND_PAGE") ||
      brandsPageState?.matches("RENDER_CURRENCY_PAGE")) {
      // return <div>Loading...</div>;
      return (
        <StateOSD
          titleBoldText="..."
          titleNormalText="Loading"
          description="This might take a few seconds, Please wait !"
        />
      )
    }
    return null;
  };
  return <>{_renderPage()}</>;
};
